import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { func, string } from 'prop-types';

class UTCaptcha extends Component {
  onChange = value => {
    this.props.onChange(value);
  };

  render() {
    return (
      <div style={this.props.style}>
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_API_KEY}
          onChange={this.onChange}
          size={this.props.size}
        />
      </div>
    );
  }
}

UTCaptcha.propTypes = {
  onChange: func.isRequired,
  size: string.isRequired
};

export default UTCaptcha;
